import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { createReverifyEmailSkippedOutbound } from '../../api/outbound/reverifyOutbounds';
import { TimeDelayButton } from '../../components/timeDelayButton';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkLoginManual } from '../../redux/actions/gameEntryActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { isLocalhostEnvironment } from '../../utils/utils';
const SKIP_BUTTON_LABEL = 'Skip this time';
export const ReverifySkipButtonContainer = () => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const tempLoginCredentials = useAppSelector((state) => state.session.tempLoginCredentials, shallowEqual);
    const onClickSkip = useCallback(() => {
        if (!tempLoginCredentials) {
            return;
        }
        socketSend(createReverifyEmailSkippedOutbound());
        const { username, password } = tempLoginCredentials;
        dispatch(thunkLoginManual({ socketSend, username, password, skipReverifyCheck: true }));
    }, [tempLoginCredentials, dispatch, socketSend]);
    if (!tempLoginCredentials) {
        return null;
    }
    return (_jsx("div", { children: _jsx(TimeDelayButton, { disabledLabel: SKIP_BUTTON_LABEL, enabledLabel: SKIP_BUTTON_LABEL, ariaLabel: SKIP_BUTTON_LABEL, variant: 'outlined', color: 'primary', numSeconds: isLocalhostEnvironment() ? 2 : 5, onClick: onClickSkip }) }));
};
